<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="消息流程类型：" prop="InstationName">
          <el-input
            placeholder="消息流程类型"
            v-model="dataForm.InstationName"
            maxlength="50"
          ></el-input>
        </el-form-item>
        <el-form-item
            label="消息者："
            >
            <el-input
                placeholder="请按右侧图标选择"
                v-model="dataForm.PartName"
            >
            <i
                slot="prefix"
                :class="['el-input__icon', 'el-icon-user-solid']"
                style="float:right;margin-right:25%"
                @click="addUser(index)"
                ></i>
            </el-input>
        </el-form-item>
      </el-form>
      <employee-picker
        v-if="formVisible"
        @pickerCallBack="employeeCallBack"
      ></employee-picker>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import EmployeePicker from "@/modules/sys/components/picker/employee";
import { mapGetters } from "vuex";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    dataForm: {
      type: Object,
      default: null
    },
    formTitle: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editFormRules: {
        InstationName: [
          { required: true, message: "消息流程名称不能空", trigger: "blur" }
        ],
        PartName: [{ required: true, message: "参与者不能空", trigger: "blur" }]
      },
      isConfirm: false,

      isAudit: 1, //是否审核
      steps: [{ StepName: "", PartName: "" }],
      formVisible: false,

      index: "",
      width: "30%"
    };
  },
  computed: {
    ...mapGetters(["GetCurrentUserInfo"])
  },
  mounted() {
    // this.loadStepData();
  },
  components: {
    OfDialog,
    EmployeePicker
  },
  methods: {
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    // //加载审批步骤
    // loadStepData() {
    //   if (this.dataForm.Id) {
    //     this.isloading = true;
    //     let params={Id:this.dataForm.Id}
    //     api.queryStationSetDetail(params).then(rep => {
    //       if (rep.data.Code === 0) {
    //         this.isAudit = rep.data.Data.length === 0 ? 0 : 1;
    //         this.dataForm= rep.data.Data;
    //       }
    //       this.isloading = false;
    //     });
    //   }
    // },
    //保存
    confirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.isConfirm = true;
          this.dataForm.ModifierId = this.GetCurrentUserInfo.Id;
          this.dataForm.Modifier = this.GetCurrentUserInfo.RealName;
          let params = Object.assign({}, this.dataForm);
          api.saveStationSet(params)
            .then(rep => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success"
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error"
                });
              }
            })
            .catch(e => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error"
              });
            });
        }
      });
    },
    //选择参与者
    addUser(index) {
      this.index = index;
      this.formVisible = true;
    },
    //人员选择回调
    employeeCallBack(val) {
      this.formVisible = false;
      if (val) {
        this.dataForm.PartName = val.RealName;
        this.dataForm.PartId = val.Id;
      }
    }
  }
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

/* .el-dialog__wrapper >>> .el-dialog .el-dialog__footer .el-button--primary {
  display: none;
} */

.el-input >>> .el-input__prefix {
  margin-left: auto;
  margin-top: 1%;
  margin-right: 10px;
}
</style>

<style>
.hide .el-button--primary {
  display: none;
}
</style>
